<ig-button class="ig-alt-btn" (trigger)="btnClick()">search</ig-button>
<span class="ig-alt-cover" (click)="btnCancel($event)"></span>





// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/alt.button/alt.button.component.html